import { auth0UserQueryOptions } from '@/features/authentication/services/Authentication/queryOptions'
import { useQuery } from '@tanstack/react-query'

export const useQueryAuth0User = () => {
  return useQuery(auth0UserQueryOptions)
}
